export const DATABASE_URLS = {
  omim: "http://www.omim.org/entry/INSERT_ID",
  orphanet:
    "http://www.orpha.net/consor/cgi-bin/OC_Exp.php?Lng=GB&Expert=INSERT_ID",
  orpha:
    "http://www.orpha.net/consor/cgi-bin/OC_Exp.php?Lng=GB&Expert=INSERT_ID",
  medgen: "http://www.ncbi.nlm.nih.gov/medgen/?term=INSERT_ID",
  genereviews: "http://www.ncbi.nlm.nih.gov/books/INSERT_ID",
  snomed_ct:
    "http://browser.ihtsdotools.org/?perspective=full&conceptId1=INSERT_ID",
  pubmed: "http://www.ncbi.nlm.nih.gov/pubmed/?term=INSERT_ID",
  mesh: "https://id.nlm.nih.gov/mesh/INSERT_ID.html",
  human_phenotype_ontology: "https://monarchinitiative.org/phenotype/INSERT_ID",
  hp: "https://monarchinitiative.org/phenotype/INSERT_ID",
  efo: "http://www.ebi.ac.uk/ols/ontologies/efo/terms?short_form=INSERT_ID",
  mondo: "https://monarchinitiative.org/disease/INSERT_ID",
};

export const DATABASE_NAMES = {
  omim: "OMIM",
  orpha: "Orphanet",
  orphanet: "Orphanet",
  medgen: "MedGen",
  genereviews: "GeneReviews",
  snomed_ct: "SNOMED_CT",
  pubmed: "PubMed",
  mesh: "MeSH",
  human_phenotype_ontology: "HPO",
  hp: "HPO",
  efo: "EFO",
  mondo: "Mondo",
};
